import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface HeaderActionsSearchStyles {
    container: InjectableCss;
    navContainer: GridItemProps;
    cartSignInMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    signInCartContainer?: GridContainerProps;
    signInGridItemContainer?: GridItemProps;
    cartGridItemContainer?: GridItemProps;
    searchContainer: InjectableCss;
    logoContainer: GridItemProps;
    parentContainer: InjectableCss;
    rightColumnContactHidden: HiddenProps;
    centerColumnContactHidden: HiddenProps;
    leftLogoHidden: HiddenProps;
    topLogoHidden: HiddenProps;
    navWrapper: InjectableCss;
}

export const HeaderActionsSearchStyles: HeaderActionsSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: flex-end;
            margin: 0 auto;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        padding: 0;
                        margin: 0;
                        justify-content: center;
                        align-items: center;
                    `,
                    css``,
                    css`
                        padding: 5px 15px 0 15px;
                    `,
                    css`
                        max-width: ${maxWidths[3]}px;
                    `,
                    css`
                        max-width: ${maxWidths[4]}px;
                    `,
                ]);
            }}
            padding: 0;
            flex-wrap: nowrap;
            align-items: center;
        `,
    },
    navContainer: {
        css: css`
            display: flex;
            justify-content: center;
            margin: 0 auto;
            & button span,
            a span {
                font-size: 14px !important;
            }
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        justify-content: center;
                        align-items: center;
                        > div:first-child {
                            display: flex;
                            justify-content: flex-end;
                        }
                        & .menu-trigger-button {
                            padding-right: 0;
                        }
                    `,
                    css`
                        max-width: ${maxWidths[3]}px;
                    `,
                    css`
                        max-width: ${maxWidths[4]}px;
                    `,
                ]);
            }}
        `,
    },
    navWrapper: {
        css: css`
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        line-height: 1;
                    `,
                    null,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
    cartSignInMenuWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            flex: 0 0 auto;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                    null,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    signInCartContainer: {
        css: css`
            & ${GridOffset} {
                width: 100%;
                margin: 0;
                justify-content: flex-end;
            }
        `,
    },
    signInGridItemContainer: {
        width: 6,
        css: css`
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            padding-right: 0;
            text-align: end;
            align-items: center;
            > div:first-child {
                display: flex;
            }
            & a span {
                font-weight: bold;
                color: ${getColor("primary.main")} !important;
            }
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        & button > div {
                            height: auto !important;
                        }
                    `,
                    null,
                    css`
                        & button > div {
                            height: auto !important;
                            align-items: center;
                        }
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },

    cartGridItemContainer: {
        width: 6,
        css: css`
            padding-top: 5px !important;
            padding-bottom: 5px !important;
            padding-left: 25px;
            padding-right: 0;
            text-align: end;

            & a span {
                color: ${getColor("primary.main")} !important;
            }
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0;
                        & a {
                            height: auto !important;
                        }
                    `,
                    null,
                    css`
                        & a {
                            height: auto !important;
                        }
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    searchContainer: {
        css: css`
            flex: 1 1 auto;
        `,
    },
    logoContainer: {
        width: [6, 4, 4, 6, 6],
        css: css`
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        flex: 1 1 auto;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    `,
                    null,
                    css`
                        flex: 1 1 auto;
                        justify-content: flex-start;
                    `,
                    null,
                    css`
                        flex: 1 1 auto;
                        justify-content: flex-start;
                    `,
                ]);
            }}
        `,
    },
    parentContainer: {
        css: css`
            background-color: ${getColor("primary.contrast")};
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        line-height: 1;
                    `,
                    null,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },

    rightColumnContactHidden: {
        below: "sm",
        css: css`
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        & div p {
                            text-align: center;
                        }
                    `,
                    css`
                        & div p {
                            text-align: right;
                            padding: 5px 15px 0 0;
                        }
                    `,
                    css`
                        & div p {
                            text-align: right;
                            padding: 5px 15px 0 0;
                        }
                    `,
                    null,
                    css`
                        & div p {
                            text-align: right;
                        }
                    `,
                ]);
            }}
        `,
    },
    centerColumnContactHidden: {
        above: "sm",
        css: css`
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        & div p {
                            text-align: center !important;
                        }
                    `,
                    null,
                    null,
                    null,
                    null,
                ]);
            }}
        `,
    },
    leftLogoHidden: {
        below: "sm",
    },
    topLogoHidden: {
        above: "sm",
        css: css`
            & a div {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            & a div img {
                width: 75%;
            }
        `,
    },
};

const HeaderActionsSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...HeaderActionsSearchStyles.parentContainer} data-test-selector="parentContainer">
        <StyledWrapper {...HeaderActionsSearchStyles.logoContainer} data-test-selector="logoContainer">
            <Hidden {...HeaderActionsSearchStyles.topLogoHidden}>
                <Zone contentId={id} zoneName="Logo" />
            </Hidden>
        </StyledWrapper>
        <StyledWrapper {...HeaderActionsSearchStyles.container}>
            <Hidden {...HeaderActionsSearchStyles.rightColumnContactHidden} data-test-selector="contactZone">
                <Zone contentId={id} zoneName="contact" />
            </Hidden>
        </StyledWrapper>
        <StyledWrapper {...HeaderActionsSearchStyles.container} data-test-selector="container">
            <StyledWrapper {...HeaderActionsSearchStyles.logoContainer} data-test-selector="logoContainer">
                <Hidden {...HeaderActionsSearchStyles.leftLogoHidden}>
                    <Zone contentId={id} zoneName="Logo" />
                </Hidden>
            </StyledWrapper>
            <StyledWrapper {...HeaderActionsSearchStyles.navWrapper} data-test-selector="searchSignInRaCartMainNav">
                <Hidden {...HeaderActionsSearchStyles.centerColumnContactHidden} data-test-selector="contactZone">
                    <Zone contentId={id} zoneName="contact" />
                </Hidden>
                <StyledWrapper
                    {...HeaderActionsSearchStyles.cartSignInMenuWrapper}
                    data-test-selector="searchSignInRaCart"
                >
                    <Hidden below="lg" {...HeaderActionsSearchStyles.searchContainer}>
                        <Zone contentId={id} zoneName="SearchFix" />
                    </Hidden>

                    <StyledWrapper {...HeaderActionsSearchStyles.signInGridItemContainer}>
                        <Zone contentId={id} zoneName="SignIn" />
                    </StyledWrapper>
                    <StyledWrapper {...HeaderActionsSearchStyles.signInGridItemContainer}>
                        <Zone contentId={id} zoneName="Or" />
                    </StyledWrapper>
                    <StyledWrapper {...HeaderActionsSearchStyles.signInGridItemContainer}>
                        <Zone contentId={id} zoneName="RequestAccount" />
                    </StyledWrapper>

                    <StyledWrapper {...HeaderActionsSearchStyles.cartGridItemContainer}>
                        <Zone contentId={id} zoneName="Cart" />
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...HeaderActionsSearchStyles.navContainer} data-test-selector="mainNav">
                    <Hidden above="md" below="md" {...HeaderActionsSearchStyles.searchContainer}>
                        <Zone contentId={id} zoneName="SearchFix" />
                    </Hidden>
                    <Zone contentId={id} zoneName="MainNavigation" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
);

const headerActionsSearch: WidgetModule = {
    component: HeaderActionsSearch,
    definition: {
        group: "Header",
        icon: "Filter",
        fieldDefinitions: [],
        displayName: "Header Actions and Search",
    },
};

export default headerActionsSearch;
